type MetaInfo = {
  title: string
  subTitle: string
  reportName?: string
}

export const MetaTitle: Record<string, MetaInfo> = {
  organization: {
    title: 'Organization',
    subTitle: 'Allen Organization',
    reportName: '1',
  },
  school: {
    title: 'School',
    subTitle: 'Allen School',
    reportName: '2',
  },
  'student-school-mapping': {
    title: 'Student School Mapping',
    subTitle: 'Allen Student School Mapping',
    reportName: '3',
  },
  'user-management': {
    title: 'User Management',
    subTitle: 'Allen User Management',
    reportName: '4',
  },
  'file-log': {
    title: 'Bulk File Log',
    subTitle: 'Allen File Log',
    reportName: '12',
  },
  'student-tracking': {
    title: 'Student Tracking',
    subTitle: 'Allen Student Tracking',
    reportName: '5',
  },
  'test-reports': {
    title: 'Test Reports',
    subTitle: 'Allen Test Reports',
    reportName: '6',
  },
  'review-test': {
    title: 'Review Test',
    subTitle: 'Allen Review Test',
    reportName: '7',
  },
  'online-attendance': {
    title: 'Online Attendance',
    subTitle: 'Allen Online Attendance',
    reportName: '8',
  },
  'online-view': {
    title: 'Online Attendance view',
    subTitle: 'Allen Online Attendance',
    reportName: '9',
  },

  'offline-attendance': {
    title: 'Offline Attendance',
    subTitle: 'Allen Offline Attendance',
    reportName: '10',
  },
  'offline-view': {
    title: 'Offline Attendance',
    subTitle: 'Allen Offline Attendance',
    reportName: '11',
  },
  setting: {
    title: 'Profile',
    subTitle: 'Allen setting',
  },
  login: {
    title: 'Login',
    subTitle: 'with credentials',
  },
  'forgot-password': {
    title: 'Forgot',
    subTitle: 'Password',
  },
  'reset-password': {
    title: 'Reset',
    subTitle: 'Password',
  },
  'change-password': {
    title: 'Change',
    subTitle: 'Password',
  },
}

export const defaultMeta: MetaInfo = {
  title: 'Allen | Education Portal',
  subTitle: 'Welcome to Allen Student Portal',
}
